import React from 'react';
import { useAppStateContext } from 'src/AppState/AppState';
import { ArrowIconWrapper, ListItemLink } from 'src/components/Tabs/Tabs.style';
import { LeftSideBar } from 'src/components/Reports/Report.style';
import { ReportsKeyType } from 'src/AppState/ConfigState/types';

type LinksArrayType = {
    titleName: string;
    iconName: string;
    qParam: string;
    firstName?: boolean;
};

interface ReportsNavigationPropsType {
    links?: Array<LinksArrayType>;
    tab: string | null;
}

interface LinksType {
    titleName: string;
    iconName: string;
    qParam: ReportsKeyType;
    firstItem?: boolean;
}

const defaultLinks: LinksType[] = [
    {
        titleName: 'Platform Reports',
        iconName: 'pen',
        qParam: 'PlatformReports',
        firstItem: true,
    },
    {
        titleName: 'Compliance Platform reports',
        iconName: 'pen',
        qParam: 'CompliancePlatformReports',
    },
    {
        titleName: 'Platform Overview',
        iconName: 'pen',
        qParam: 'PlatformOverview',
    },
    {
        titleName: 'Backoffice Reports',
        iconName: 'pen',
        qParam: 'BackofficeReports',
    },
    {
        titleName: 'Casino Dashboard',
        iconName: 'pen',
        qParam: 'CasinoDashboard',
    },
    {
        titleName: 'Compliance Dashboard',
        iconName: 'pen',
        qParam: 'ComplianceDashboard',
    },
    {
        titleName: 'DepositRestrictions',
        iconName: 'pen',
        qParam: 'DepositRestrictions',
    },
    {
        titleName: 'Market KPI Dashboard',
        iconName: 'pen',
        qParam: 'MarketKPIDashboard',
    },
    {
        titleName: 'Marketing Dashboard',
        iconName: 'pen',
        qParam: 'MarketingDashboard',
    },
    {
        titleName: 'Profit And Loss KPIs',
        iconName: 'pen',
        qParam: 'ProfitAndLossKPIs',
    },
    {
        titleName: 'Trading Overview',
        iconName: 'pen',
        qParam: 'TradingOverview',
    },
    {
        titleName: 'Promo Prediction',
        iconName: 'pen',
        qParam: 'PromoPrediction',
    },
    {
        titleName: 'Promotion Reports',
        iconName: 'pen',
        qParam: 'PromotionReports',
    },
    {
        titleName: 'Marketing Overview',
        iconName: 'pen',
        qParam: 'MarketingOverview',
    },
    {
        titleName: 'Racecourse Dashboard',
        iconName: 'pen',
        qParam: 'RacecourseDashboard',
    },
    {
        titleName: 'Retention Dashboard',
        iconName: 'pen',
        qParam: 'RetentionDashboard',
    },
    {
        titleName: 'Payments Overview',
        iconName: 'pen',
        qParam: 'PaymentsOverview',
    },
    {
        titleName: 'Transactions Dashboard',
        iconName: 'pen',
        qParam: 'TransactionsDashboard',
    },
    {
        titleName: 'Accounts',
        iconName: 'pen',
        qParam: 'Accounts',
    },
    {
        titleName: 'Affiliate',
        iconName: 'pen',
        qParam: 'Affiliate',
    },
    {
        titleName: 'Affiliate Dashboard',
        iconName: 'pen',
        qParam: 'AffiliateDashboard',
    },
    {
        titleName: 'Betting',
        iconName: 'pen',
        qParam: 'Betting',
    },
    {
        titleName: 'Bespoke Reports',
        iconName: 'pen',
        qParam: 'BespokeReports',
    },
    {
        titleName: 'Segmentation',
        iconName: 'pen',
        qParam: 'Segmentation',
    },
    {
        titleName: 'Account Balances',
        iconName: 'pen',
        qParam: 'AccountBalances',
    },
    {
        titleName: 'SRG Dashboard',
        iconName: 'pen',
        qParam: 'SRGDashboard',
    },
    {
        titleName: 'Conversions',
        iconName: 'pen',
        qParam: 'Conversions',
    },
    {
        titleName: 'Campaigns Dashboard',
        iconName: 'pen',
        qParam: 'CampaignsDashboard',
    },
    {
        titleName: 'Rolling Net Deposits',
        iconName: 'pen',
        qParam: 'RollingNetDeposits',
    },
    {
        titleName: 'Symplify Dashboard',
        iconName: 'pen',
        qParam: 'SymplifyDashboard',
    },
    {
        titleName: 'SRG Compliance',
        iconName: 'pen',
        qParam: 'SRGCompliance',
    },
    {
        titleName: 'Symplify Stats',
        iconName: 'pen',
        qParam: 'SymplifyStats',
    },
    {
        titleName: 'Blocked Players Report',
        iconName: 'pen',
        qParam: 'BlockedPlayersReport',
    },
    {
        titleName: 'Liftetime Value',
        iconName: 'pen',
        qParam: 'LiftetimeValue',
    },
    {
        titleName: 'Live Chat',
        iconName: 'pen',
        qParam: 'LiveChat',
    },
    {
        titleName: 'Bonus Engine',
        iconName: 'pen',
        qParam: 'BonusEngine',
    },
    {
        titleName: 'Targeting Attributes',
        iconName: 'pen',
        qParam: 'TargetingAttributes',
    },
    {
        titleName: 'Racing Loyalty Offers',
        iconName: 'pen',
        qParam: 'CheltenhamOffers',
    },
    {
        titleName: 'Audits Customer Lists',
        iconName: 'pen',
        qParam: 'AuditsCustomerLists',
    },
    {
        titleName: 'Customer Retention',
        iconName: 'pen',
        qParam: 'CustomerRetention',
    },
    {
        titleName: 'Casino Audit',
        iconName: 'pen',
        qParam: 'CasinoAudit',
    },
];

interface ReportsLeftMenuElementsType {
    index: number;
    isActive: boolean;
    parameters: { tab: string };
    item: LinksType;
}

const LinkWrapperReusable = (props: ReportsLeftMenuElementsType): React.ReactElement => {
    return (
        <ListItemLink
            route='global:reporting'
            isActive={props.isActive}
            parameters={props.parameters}
            key={props.index}
        >
            {props.item.titleName}
            <ArrowIconWrapper
                isActive={props.isActive}
                position='right'
            />
        </ListItemLink>
    );
};

export const Reports = (props: ReportsNavigationPropsType): JSX.Element => {
    const {
        configState: {
            config: { tableauDashboards, workbookView },
        },
    } = useAppStateContext();

    const reportsLeftMenuElements = defaultLinks.map((item, index) => {
        const isActive = item.qParam === props.tab || (props.tab === null && item.firstItem === true);
        const parameters = { tab: item.qParam };

        if (tableauDashboards === true) {
            if (['PlatformReports', 'CompliancePlatformReports', ...Object.keys(workbookView)].includes(item.qParam)) {
                return (
                    <LinkWrapperReusable
                        index={index}
                        isActive={isActive}
                        parameters={parameters}
                        item={item}
                        key={item.qParam}
                    />
                );
            }
        } else if (['PlatformReports', 'CompliancePlatformReports'].includes(item.qParam)) {
            return (
                <LinkWrapperReusable
                    index={index}
                    isActive={isActive}
                    parameters={parameters}
                    item={item}
                    key={item.qParam}
                />
            );
        }
    });

    return <LeftSideBar>{reportsLeftMenuElements}</LeftSideBar>;
};
